import { Fragment } from 'react';
import { useI18n } from '../i18n';
import { ADDRESS_LINES, MAP_EMBED, MAPS_URL, PHONE } from '../constants';
import { Reveal } from './Reveal';

/** Visit info (address, hours, contacts, actions) beside an embedded map. */
export const Visit = () => {
  const { t } = useI18n();
  return (
    <section className="visit sec" id="visitar">
      <div className="wrap">
        <Reveal className="sec-head">
          <span className="kicker">{t.visit.kicker}</span>
          <h2>{t.visit.title}</h2>
        </Reveal>

        <div className="row">
          <Reveal>
            <div className="info-block">
              <div className="h">{t.visit.addressLabel}</div>
              <p>
                {ADDRESS_LINES.map((line, i) => (
                  <Fragment key={line}>
                    {i > 0 && <br />}
                    {line}
                  </Fragment>
                ))}
              </p>
            </div>
            <div className="info-block">
              <div className="h">{t.visit.hoursLabel}</div>
              <p>{t.visit.hours}</p>
              <p className="note">{t.visit.note}</p>
            </div>
            <div className="info-block">
              <div className="h">{t.visit.contactLabel}</div>
              <p>Tel: {PHONE}</p>
            </div>
            <div className="visit-actions">
              <a className="btn btn-gold" href={MAPS_URL} target="_blank" rel="noopener">
                {t.visit.map}
              </a>
            </div>
          </Reveal>

          <Reveal className="map" delay={1}>
            <iframe
              title="CR7 Museu Funchal"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src={MAP_EMBED}
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
